import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { linkList } from '../../redux/slice/LinkList';
import { updateLinkStatus } from '../../redux/slice/UpdateLinkStatus';
import Loader from '../../components/loader/Loader';
import moment from 'moment';
import Modal from '../../components/modal/Modal';
import EditLinkForm from '../../components/forms/EditLinkForm';
import { Form } from 'react-bootstrap';
import { Copy, QrCode } from 'lucide-react';
import { toast } from 'react-toastify';
import { FaCopy } from 'react-icons/fa';
import '../../assets/css/LinkPage.css';
import { useNavigate } from 'react-router-dom';
import QRCode from './QRCode';
import UpdateLink from './UpdateLink';
import BiolinkSubscription from '../biolink-page/BiolinkSubscription';


export default function LinkPage({ setShowPlanPage }) {

    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false)
    const [show2, setShow2] = useState(false);
    const [bool, setBool] = useState(false)
    const [linkData, setLinkData] = useState('')
    const [showEditModal, setShowEditModal] = useState(false);
    const [editShow, setEditShow] = useState(false);
    const [selectedLink, setSelectedLink] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const data = useSelector((state) => state.linkList.data);
    // console.log(selectedLink, 'data')

    useEffect(() => {
        setLoader(true);
        dispatch(linkList({ navigate })).finally(() => setLoader(false));
    }, [bool]);

    const subscription_fun = () => {
        setShow2(true)
    }

    useEffect(() => {
        if (data && data.length > 0) {
            const hasPaidPlan = data.some(item => {
                const planType = (item.plan_type || '').toLowerCase();
                return planType.includes('paid');
            });
            if (setShowPlanPage) {
                setShowPlanPage(hasPaidPlan);
            }
        } else {
            if (setShowPlanPage) {
                setShowPlanPage(false);
            }
        }
    }, [data, setShowPlanPage]);

    const formatDate = (date) => {
        if (!date) return 'N/A';
        const formatted = moment(date).locale('en').format('DD-MMM-YYYY');
        return formatted === 'Invalid date' ? 'N/A' : formatted;
    };

    const formatUrl = (url) => {
        if (!url) return '';
        // Add protocol if missing
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return `https://${url}`;
        }
        return url;
    };

    const getShortUrl = (shortCode) => {
        const baseUrl = (process.env.REACT_APP_BASE_URL).replace(/\/$/, '');
        return `${baseUrl}/o/${shortCode}`;
    };

    const handleEdit = (item) => {
        setSelectedLink(item);
        setEditShow(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedLink(null);
    };

    const handleRenew = (item) => {
        navigate('/plans', { state: item })
    };

    const handleStatusToggle = async (item) => {
        if (
            item.status?.toLowerCase() === 'inactive' &&
            item.status_by?.toLowerCase() === 'admin'
        ) {
            return;
        }

        const currentStatus = item.status || '';
        const newStatus = currentStatus.toLowerCase() === 'active' ? 'Inactive' : 'Active';

        try {
            const result = await dispatch(updateLinkStatus({
                id: item._id,
                status: newStatus
            }));

            if ((result.payload?.status === 200 || result.payload?.status === 201) && result.payload?.data?.status === true) {
                toast.success(result.payload?.data?.message || 'Link status updated successfully', {
                    position: "bottom-right",
                    closeOnClick: true
                });
                // Refresh the link list
                await dispatch(linkList());
            } else {
                const errorMessage = result.payload?.data?.message || 'Failed to update link status';
                toast.error(errorMessage, { position: "bottom-right" });
            }
        } catch (error) {
            console.error('Error updating link status:', error);
            toast.error('An error occurred. Please try again.', { position: "bottom-right" });
        }
    };

    const handleCopyUrl = (shortUrl) => {
        navigator.clipboard.writeText(shortUrl).then(() => {
            toast.success('URL copied to clipboard!', {
                position: "bottom-right",
                closeOnClick: true
            });
        }).catch((err) => {
            console.error('Failed to copy:', err);
            toast.error('Failed to copy URL', { position: "bottom-right" });
        });
    };

    const navigate_fun = (id) => {
        navigate('/link-analysis', { state: id })
    }

    const handleQR = (data) => {
        setShow(true)
        setLinkData(data)
    }

    return (
        <>
            {loader ?
                <div className='layout d-flex justify-content-center align-items-center p-5 mt-2'>
                    <Loader />
                </div>
                : data.length > 0 ?
                    <>
                        {/* <Modal
                            show={showEditModal}
                            handleClose={handleCloseEditModal}
                            header="Edit Link"
                            FormPage={EditLinkForm}
                            FormPageProps={{
                                linkItem: selectedLink,
                                handleClose: handleCloseEditModal
                            }}
                            size="md"
                        /> */}
                        <div className="links-grid">
                            {data.map((item) => {
                                const url =
                                    item.plan_type === "free"
                                        ? "https://ad1.free/"
                                        : "https://ad1.now/";

                                return (
                                    <div key={item.id} className="link-card">
                                        <div className="link-card-header">
                                            <h6 className="link-title">Link Details</h6>

                                            <div className="d-flex align-items-center gap-2">
                                                {item.status?.toLowerCase() !== "expired" && (
                                                    <Form.Check
                                                        type="switch"
                                                        id={`status-switch-${item.id}`}
                                                        checked={item.status?.toLowerCase() === "active"}
                                                        onChange={() => handleStatusToggle(item)}
                                                        disabled={
                                                            item.status?.toLowerCase() === "inactive" &&
                                                            item.status_by?.toLowerCase() === "admin"
                                                        }
                                                        label=""
                                                        style={{ margin: 0 }}
                                                    />
                                                )}

                                                <span
                                                    className={`status-badge status-${item.status?.toLowerCase()}`}
                                                >
                                                    {item.status?.toLowerCase() === "inactive" &&
                                                    item.status_by?.toLowerCase() === "admin"
                                                        ? "Inactive by Admin"
                                                        : item.status}
                                                </span>
                                            </div>
                                        </div>

                                        <div className="link-card-body">
                                            <div className="link-field">
                                                <div className="link-field-header">
                                                    <label>Long URL:</label>

                                                    <div className="link-action-buttons">
                                                        {item.status?.toLowerCase() !== "expired" && (
                                                            <button
                                                                className="btn-link-action btn-edit"
                                                                onClick={() => handleEdit(item)}
                                                                title="Edit Link"
                                                            >
                                                                Edit
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>

                                                <a
                                                    rel="noopener noreferrer"
                                                    className="link-value long-url"
                                                    title={item.long_url}
                                                    style={{ width: "fit-content" }}
                                                >
                                                    {item.long_url}
                                                </a>
                                            </div>

                                            <div className="link-field">
                                                <label>Short URL:</label>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <a
                                                        href={`${url}o/${item.short_code}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="link-value short-url text-primary"
                                                        style={{ width: "fit-content" }}
                                                    >
                                                        {`${url}o/${item.short_code}`}
                                                    </a>

                                                    <div className="d-flex align-items-center">
                                                        <button
                                                            className="btn btn-sm btn-secondary"
                                                            onClick={() =>
                                                                handleCopyUrl(
                                                                    `${url}o/${item.short_code}`
                                                                )
                                                            }
                                                            title="Copy URL"
                                                        >
                                                            <Copy size={15} className="mb-1" />
                                                        </button>

                                                        <button
                                                            className="ms-2 btn btn-sm btn-info"
                                                            onClick={() => handleQR(item)}
                                                            title="QR Code"
                                                        >
                                                            <QrCode size={15} className="mb-1" />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="link-info-row">
                                                <div className="link-info-col">
                                                    <label>Start Date:</label>

                                                    <p className="link-value date-value">
                                                        {formatDate(item.start_date)}
                                                    </p>
                                                </div>

                                                <div className="link-info-col">
                                                    <label>Expire Date:</label>

                                                    <p className="link-value date-value">
                                                        {formatDate(item.expire_date)}
                                                    </p>
                                                </div>

                                                {item.plan_type === "free" &&
                                                    item.status === "Expired" ? (
                                                    <div className="link-info-col">
                                                        <label className="link-info-label-spacer" aria-hidden="true">&nbsp;</label>
                                                        <button
                                                            className="btn-link-action btn-renew link-info-action-box"
                                                            onClick={() => handleEdit(item)}
                                                            title="Renew Link"
                                                        >
                                                            Renew @ FREE
                                                        </button>
                                                    </div>
                                                ) : item.plan_type === "paid" ? (
                                                    <div className="link-info-col">
                                                        <label className="link-info-label-spacer" aria-hidden="true">&nbsp;</label>
                                                        <button
                                                            className="btn-link-action btn-renew link-info-action-box"
                                                            onClick={() => handleRenew(item)}
                                                            title="Renew Link"
                                                        >
                                                            Renew
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div className="link-info-col">
                                                        <label className="link-info-label-spacer" aria-hidden="true">&nbsp;</label>
                                                    </div>
                                                )}

                                                <div className="link-info-col">
                                                    <label>Plan Type:</label>

                                                    <span
                                                        className={`plan-type-badge link-info-action-box plan-type-${(
                                                            item.plan_type || "N/A"
                                                        )
                                                            .toLowerCase()
                                                            .replace(/\s+/g, "-")
                                                            .replace(/\//g, "\\/")}`}
                                                    >
                                                        {item.plan_type || "N/A"}
                                                    </span>
                                                </div>

                                                <div className="link-info-col">
                                                    <label>Total Clicks:</label>

                                                    <button
                                                        className="btn btn-sm btn-secondary link-info-action-box"
                                                        onClick={() =>
                                                            item.plan_type === "free" &&
                                                                localStorage.getItem("biolink_status") ===
                                                                "free"
                                                                ? subscription_fun()
                                                                : navigate_fun(item)
                                                        }
                                                    >
                                                        {item.total_clicks}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                    :
                    <div className='layout mt-2 text-center no-data'>No data found</div>
            }
            <QRCode show={show} setShow={setShow} linkData={linkData} />
            <BiolinkSubscription show2={show2} setShow2={setShow2} bool={bool} setBool={setBool} />
            <UpdateLink show={editShow} setShow={setEditShow} bool={bool} setBool={setBool} linkItem={selectedLink} />
        </>
    )
}